import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { buttonBaseStyles, checkboxStyles } from "@store/theme/common/mixins";

import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(orderUploadStyles, {
    downloadTemplateButton: {
        css: css`
            ${buttonBaseStyles("solid")}
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["20px", null, "40px", null, null], properties: ["margin-bottom"] }],
                    mediaOptions.min,
                )}
        `,
        variant: "secondary",
    },
    includeFirstRowCheckbox: {
        css: css`
            margin: 10px 0 20px;
            display: flex;
            ${checkboxStyles()}
        `,
    },
    fileUploader: {
        buttonProps: {
            variant: "secondary",
            css: css`
                ${buttonBaseStyles("solid")}
                height: 40px;
                margin: 0 0 10px 15px;
                align-self: flex-end;
            `,
        },
    },
    cancelUploadButton: {
        variant: "secondary",
        css: css`
            ${buttonBaseStyles("solid")}
            float: right;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    uploadFileButton: {
        css: css`
            ${buttonBaseStyles("solid")}
            float: right;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 10px;
                            width: 100%;
                        `,
                        css`
                            margin-left: 15px;
                            width: initial;
                        `,
                    ],
                    "min",
                )}
        `,
    },
});
